module.exports = __webpack_public_path__ + "static/webstorm1b-fca40eb80fc934d9f0d06ce1c1ba4e37.png";